import { render, staticRenderFns } from "./r-item-boost-rule-dialog.vue?vue&type=template&id=609d84a6&scoped=true"
import script from "./r-item-boost-rule-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-boost-rule-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-boost-rule-dialog.vue?vue&type=style&index=0&id=609d84a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d84a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609d84a6')) {
      api.createRecord('609d84a6', component.options)
    } else {
      api.reload('609d84a6', component.options)
    }
    module.hot.accept("./r-item-boost-rule-dialog.vue?vue&type=template&id=609d84a6&scoped=true", function () {
      api.rerender('609d84a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/boost/r-item-boost-rule-dialog.vue"
export default component.exports